/**
 * 将波形图的x轴[startIndex, endIndex]范围转换为0-360度
 * 用法:
 *  先处理波形图的数据
 *    wavedataX = generateXAxisData(wavedataY.data.length, chartData.startIndex, chartData.endIndex);
 *    dataX = generateXAxisData(dataY.data.length, res.data.data.startIndex, res.data.data.endIndex);
 *  然后使用
 *   this.$refs.waveg.setchart(wavex, wavey, dataX, dataY, title+' '+dataY.name+  ' 历史', thistime, {
 *    startIndex: res.data.data.startIndex,
 *    endIndex: res.data.data.endIndex,
 *    length: res.data.data.waveValue.waveX.length
 *  });
 * */
export function generateXAxisData(length, startIndex, endIndex, range=360) {
  if(endIndex > length) {
    endIndex = length - 1;
  }
  if (startIndex < 0 || startIndex > length) {
    startIndex = 0;
  }
  console.log("generateXAxisData", length, startIndex, endIndex)
  let xAxisData = new Array(length).fill(0);
  let step = range / (endIndex - startIndex);

  for (let i = 0; i < length; i++) {
    if (i >= startIndex) {
      xAxisData[i] = (i - startIndex) * step;
    } else {
      xAxisData[i] = i - startIndex;
    }
  }

  return xAxisData;
}



// WEBPACK FOOTER //
// ./src/js/Tools.js